import React, { useEffect, useState, useMemo } from "react";
import { IArticle } from "../../../../shared/interface/article";
import { useDaxi } from "../../services/useDaxi";
import { ISubcategoryAPIResponse } from "../../../../shared/interface/subcategory";
import { getSubcategoryAPIPath } from "../../services/paths";
import { SubCategoryList } from "./SubCategoryList";

interface IProps {
  articles?: IArticle[];
  labelId?: string;
  categorySlug: string;
  subcategorySlug: string;
  "data-id"?: string;
}

export const SubCategoryListController = ({
  categorySlug,
  subcategorySlug,
  "data-id": dataId,
}: IProps) => {
  const [loading, setLoading] = useState<boolean>(true);

  const subcategoryRes = useDaxi<ISubcategoryAPIResponse>(
    getSubcategoryAPIPath(categorySlug, subcategorySlug),
    {
      xhr: true,
      shouldExecute: loading,
    }
  );
  const data = subcategoryRes?.data;
  const articles: IArticle[] = useMemo(() => data?.articles || [], [
    data?.articles,
  ]);

  useEffect(() => {
    if (!articles || articles.length === 0) return;
    setLoading(false);
  }, [articles]);

  return (
    <SubCategoryList
      category={categorySlug}
      subcategory={subcategorySlug}
      articles={articles}
      loading={loading}
      data-id={dataId}
    />
  );
};
